<app-page-header icon="list_alt" title="Adjuntos" subtitle="Listado de adjuntos para los trámites del sistema"></app-page-header>

<div class="barra-superior">
  <div class="container">
    <button mat-stroked-button class="btn-volver" (click)="volver()">
      <mat-icon>arrow_back</mat-icon> Volver
    </button>
  </div>
</div>

<app-loading *ngIf="!flagLoaded" class="m-5"></app-loading><br>

<div *ngIf="flagLoaded" class="profile-area pb-70 contenido-tabla">
    <div class="container">

        <div class="profile-courses-quizzes">
            <h3>Listado de Adjuntos</h3>
            <a routerLink="/adjunto-alta"><button mat-raised-button mat-button color="primary"><mat-icon
                        aria-hidden="false" aria-label="Example home icon">add</mat-icon> Nuevo
                    adjunto</button></a>
            <hr>
            <div *ngIf="flagLoaded">
                <mat-form-field>
                    <mat-label>Filtrar</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Certificado de..." autocomplete="off">
                </mat-form-field>
                <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort>
                    <!-- Column -->
                    <ng-container matColumnDef="nombre">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                        <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                    </ng-container>
                    <!-- Column -->
                    <ng-container matColumnDef="descripcion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción </th>
                        <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                    </ng-container>
                    <!-- Column -->
                    <ng-container matColumnDef="_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="verAdjunto(element._id)" type="button" class="btn btn-warning"><i class="fas fa-edit"></i></button>
                        </td>
                    </ng-container>          
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="example-element-row"></tr>
                </table>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"></mat-paginator>
            </div>
        </div>
    </div>
</div>
